<template>
    <v-btn
        color="secondqry"
        elevation="0"
        class="ml-1 px-1"
        variant="plain"
        rounded="sm"
        size="small"
    >
        <v-icon v-if="icon" class="mr-2" size="small">
            {{ icon }}
        </v-icon>
        <span v-if="title">{{ title }}</span>
    </v-btn>
</template>
<script lang="ts">
import { Prop } from "vue-facing-decorator";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class CustomToolbarBtn extends Vue {
    @Prop({ default: null }) icon: string;
    @Prop({ default: null }) title: string;

    // click(evt) {
    //     this.$emit("click", evt);
    // }
}

export default toNative(CustomToolbarBtn);
</script>
<style lang="css" scoped></style>
